import type { PayloadAction } from '@reduxjs/toolkit';
import { createAction, createSlice } from '@reduxjs/toolkit';

import type { Policy } from '../../components';
import type { Network, ResponseError } from '../../types';
import type { SignupFormDataType } from './types';

export const initialState = {
    loading: false,
    formData: {
        fullname: '',
        email: '',
        password: '',
        phone: '',
        privacySha: '',
        termsSha: '',
        reCaptchaToken: <string | undefined>undefined,
        projectId: <string | undefined>undefined,
        lang: <string | undefined>undefined,
        providerId: <number | undefined>undefined,
        utmCampaign: <string | undefined>undefined,
        utmContent: <string | undefined>undefined,
        utmMedium: <string | undefined>undefined,
        utmSource: <string | undefined>undefined,
        utmTerm: <string | undefined>undefined,
    },
    error: <ResponseError | null>null,
    policy: <Policy | null>null,
};

const singupSlice = createSlice({
    name: 'signup',
    initialState,
    reducers: {
        setLoading: (state, { payload }: PayloadAction<boolean>) => {
            state.loading = payload;
        },
        setError: (state, { payload }: PayloadAction<ResponseError | null>) => {
            state.error = payload;
        },
        updateFormData: (state, { payload }: PayloadAction<SignupFormDataType>) => {
            state.formData = {
                ...state.formData,
                ...payload,
            };
        },
        setPolicy: (state, { payload }: PayloadAction<Policy | null>) => {
            state.policy = payload;
        },
    },
});

const signup = createAction('auth/signup');
const networkSignup = createAction(
    'auth/networkSignup',
    (
        network: Network,
        projectId?: string,
        lang?: string,
        providerId?: string,
        utmCampaign?: string,
        utmContent?: string,
        utmMedium?: string,
        utmSource?: string,
        utmTerm?: string,
    ) => ({
        payload: { network, projectId, lang, providerId, utmCampaign, utmContent, utmMedium, utmSource, utmTerm },
    }),
);

export default singupSlice.reducer;

const { setLoading, updateFormData, setError, setPolicy } = singupSlice.actions;

export const signupActions = {
    setLoading,
    setError,
    setPolicy,
    updateFormData,
    signup,
    networkSignup,
};
